import { useEffect, useState } from "react";
import { Heading,Container,VStack,Box } from "@chakra-ui/react";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm.jsx";
import { loadStripe } from "@stripe/stripe-js";
import { server } from "../../redux/store.js";
import axios from "axios";
function Payment() {
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState("");

  const loadPublickey = async()=>{
    const {data} = await axios.get(`${server}/config`);
    setStripePromise(loadStripe(data.publishableKey))
  }
  useEffect(() => {
   
    loadPublickey();
  }, []);
  
  const loadSecretKey = async()=>{
    const {data} = await axios.post(`${server}/create-payment-intent`);
    setClientSecret(data.client_secret)
  }

  useEffect(() => {
    loadSecretKey();
    
  }, []);

  return (
    <>
      <Container h="90vh" p="16">
      <Box bg="yellow.400" p={'2'} css={{ borderRadius: '8px 8px 0 0' }}>
        <Heading children="Payment Portal" colorScheme={'yellow'} my="4" textAlign={'center'} />
      </Box>
      
      <VStack
        boxShadow={'lg'}
        alignItems="stretch"
        borderRadius={'lg'}
        spacing="2px"
      >
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm />
        </Elements>
      )}
      </VStack>
      </Container>

    </>
  );
}

export default Payment;